import constants from '../constants/app-constants.js'
import dispatcher from '../dispatcher/dispatcher.js'

export let limitarActions = {
	limitarCartas: () => {
		dispatcher.dispatch({
			actionType: constants.LIMITAR
		})
	}
}

export let embaralharActions = {
	embaralharCartas: () => {
		dispatcher.dispatch({
			actionType: constants.EMBARALHAR
		})
	}
}

export let distribuirActions = {
	distribuirCartas: () => {
		dispatcher.dispatch({
			actionType: constants.DISTRIBUIR
		})
	}
}

export let numeroJogadoresActions = {
	definirNumero: (qtd) => {
		dispatcher.dispatch({
			actionType: constants.QTDJOGADORES,
			payload: qtd
		})
	}
}

export let numeroCartasActions = {
	definirNumero: (qtd) => {
		dispatcher.dispatch({
			actionType: constants.QTDCARTAS,
			payload: qtd
		})
	}
}

export let proximoJogadorActions = {
	proximo: () => {
		dispatcher.dispatch({
			actionType: constants.PROXJOGADOR,
		})
	}
}

export let preparaJogoActions = {
	prepara: () => {
		dispatcher.dispatch({
			actionType: constants.PREPARAJOGO,
		})
	}
}

export let statusCartas = {
	atualiza: (cartas) => {
		dispatcher.dispatch({
			actionType: constants.STATUSCARTAS,
			payload: cartas
		})
	}
}

export let nomeJogadorActions = {
	definirNome: (nome) => {
		dispatcher.dispatch({
			actionType: constants.NOMEJOGADOR,
			payload: nome
		})
	}
}

export let cartaXActions = {
	definirCarta: (carta) => {
		dispatcher.dispatch({
			actionType: constants.CARTAX,
			payload: carta
		})
	}
}

export let historiaActions = {
	iniciaHistoria: () => {
		dispatcher.dispatch({
			actionType: constants.INICIAHISTORIA,
		})
	},	
	sequenciaNumero: () => {
		dispatcher.dispatch({
			actionType: constants.SEQUENCIANUMERO,
		})
	},
	sequenciaCarta: (id) => {
		dispatcher.dispatch({
			actionType: constants.SEQUENCIACARTA,
			payload: id
		})
	},
	sequenciaHistoria: (txt) => {
		dispatcher.dispatch({
			actionType: constants.SEQUENCIAHISTORIA,
			payload: txt
		})
	}
}

export let mudaInglesActions = {
	ingles: () => {
		dispatcher.dispatch({
			actionType: constants.MUDAINGLES,
		})
	}
}

export let mudaPortuguesActions = {
	portugues: () => {
		dispatcher.dispatch({
			actionType: constants.MUDAPORTUGUES,
		})
	}
}




// WEBPACK FOOTER //
// ./src/actions/app-actions.js